import { Collapse } from "antd";
import styled from "styled-components";
import AppCard from "../AppComponents/AppCard";
import { blue } from "@ant-design/colors";

export const StyledFlexDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const StyledExpandedCard = styled(AppCard)`
  border: 1px dashed ${blue[3]} !important;
`;

export const StyledCollapse = styled(Collapse)`
  border-radius: ${({ theme }) => theme.cardRadius};

  .ant-collapse-item {
    background: ${({ theme }) => theme.palette.background.secondary};

    .ant-collapse-header {
      border-radius: ${({ theme }) => theme.cardRadius} !important;
      background: ${({ theme }) =>
        theme.palette.background.secondary}!important;
    }

    .ant-collapse-content {
      background: ${({ theme }) => theme.palette.background.paper}!important;
      border: 1px dashed ${({ theme }) => theme.palette.borderColor}!important;

      .ant-collapse-content-box {
        background: inherit !important;
      }

      &.ant-collapse-content-active {
        border-radius: 0 0 ${({ theme }) => theme.cardRadius}
          ${({ theme }) => theme.cardRadius}!important;
        padding: 5px;
        // background:transparent;
      }
    }
  }
`;
